import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";


import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";

import AddQuickScore from "../../components/faculty/AddQuickScore";

const AddScores = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();

  useEffect(() => {}, []);


  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Add Scores" showBack={true} />
        <AddQuickScore jwt={_jwt} school={_school} initShowDialog={true} />
      </Container>
    </>
  );
};

export default AddScores;
